/*----- Core -----*/
import React     from 'react'
import styled    from 'styled-components'
import PropTypes from 'prop-types'

/*----- Commons -----*/
import Device from '../../commons/Device'

const StyledCardListContainer = styled.section`
	display: grid;
	grid-template-columns: 100%;
	grid-column-gap: 0;
	grid-template-columns: repeat(2, 50%);
	@media ${ Device.lg } {
		grid-template-columns: repeat(4, 25%);
		grid-column-gap: 16px;
	}
`

/*----- Export -----*/
const CardListContainer = ({ children }) => (
	<StyledCardListContainer className="card-list-container">
		{ children }
	</StyledCardListContainer>
)
export default CardListContainer

/*----- PropTypes -----*/
CardListContainer.propTypes = {
  children: PropTypes.node.isRequired
}
